"use strict";

exports.__esModule = true;
exports["default"] = CircleUp;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CircleUp(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M255.945 511.008C396.871 511.008 511 396.816 511 255.938 511 115.121 396.871.992 255.945.992 115.207.992 1 115.121 1 255.938c0 140.878 114.207 255.07 254.945 255.07zM88.221 246.968l144.958-145.051c3.484-3.234 6.938-5.484 10.672-6.953 3.594-1.594 7.782-2.438 12.016-2.438 4.219 0 8.422.891 12.484 2.562 3.438 1.422 6.751 3.594 9.876 6.391L423.56 246.968c6.156 5.985 9.532 14.079 9.532 22.735 0 8.75-3.407 16.892-9.673 22.923-5.578 5.642-13.797 8.954-22.453 8.954-8.657 0-16.97-3.312-22.798-9.048l-90.144-90.19v184.88c0 17.781-14.391 32.22-32.157 32.22s-32.173-14.454-32.173-32.22V202.436l-90.003 90.034c-5.828 5.798-14.125 9.126-22.719 9.126-8.625 0-16.907-3.328-22.72-9.126-12.468-12.578-12.468-32.986-.031-45.502z"
  }));
}